import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { approveAgentRequest, approveAgentRequestFailure, approveAgentRequestSuccess, fetchAgentRequestDetail, fetchAgentRequestDetailFailure, fetchAgentRequestDetailSuccess, fetchAgentsRequestsList, fetchAgentsRequestsListFailure, fetchAgentsRequestsListSuccess, rejectAgentRequest, rejectAgentRequestFailure, rejectAgentRequestSuccess } from './agents-requests.action';
import { Router } from '@angular/router';

@Injectable()
export class AgentsRequestsEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAgentsRequestsList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Admin/AgentApplication/Get?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchAgentsRequestsListSuccess({ response: result })),
          catchError((error) => of(fetchAgentsRequestsListFailure({ error })))
        )
      )
    )
  );

  fetchDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAgentRequestDetail),
      mergeMap((action) =>
        this.CrudService.getData('Admin/AgentApplication/' + action.payload.id).pipe(
          map((result) => fetchAgentRequestDetailSuccess({ response: result })),
          catchError((error) => of(fetchAgentRequestDetailFailure({ error })))
        )
      )
    )
  );

  approveAgentRequestEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(approveAgentRequest),
      mergeMap((action: any) =>
        this.CrudService.postData('Admin/AgentApplication/approve', action.payload).pipe(
          tap((result) => {
            const msg = result.successful ? 'Agent Request Approved successfully' : result.message;
            const cls = result.successful ? 'success' : 'danger';
            this.snackBar.open(msg, '', {
              duration: 3000,
              panelClass: cls,
            });
            // Only navigate on success
            if (result.successful) {
              this.router.navigate(['/agent-requests']);
            }
          }),
          mergeMap((res) => {
            if (res.successful) {
              return of(
                approveAgentRequestSuccess({ response: res.result }),
              );
            } else {
              return of(approveAgentRequestFailure({ error: res.message }));
            }
          }),
          catchError((error) => {
            // Show error message for actual HTTP errors
            this.snackBar.open(
              error?.error?.message || error?.message || error  || 'An unexpected error occurred',
              '',
              { duration: 3000, panelClass: 'danger' }
            );
            return of(approveAgentRequestFailure({ error }));
          })
        )
      )
    )
  );

  rejectAgentRequestEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rejectAgentRequest),
      mergeMap((action: any) =>
        this.CrudService.postData('Admin/AgentApplication/reject', action.payload).pipe(
          tap((result) => {
            const msg = result.successful ? 'Agent Request rejected and reason communicated through mail' : result.message;
            const cls = result.successful ? 'success' : 'danger';
            this.snackBar.open(msg, '', {
              duration: 3000,
              panelClass: cls,
            });
            // Only navigate on success
            if (result.successful) {
              this.router.navigate(['/agent-requests']);
            }
          }),
          mergeMap((res) => {
            if (res.successful) {
              return of(
                rejectAgentRequestSuccess({ response: res.result }),
              );
            } else {
              return of(rejectAgentRequestFailure({ error: res.message }));
            }
          }),
          catchError((error) => {
            // Show error message for actual HTTP errors
            this.snackBar.open(
              error?.error?.message || error?.message || error || 'An unexpected error occurred',
              '',
              { duration: 3000, panelClass: 'danger' }
            );
            return of(rejectAgentRequestFailure({ error }));
          })
        )
      )
    )
  );

}
